/**
 * @freesewing/plugin-sprinkle | v2.18.0
 * A FreeSewing plugin to bulk-add snippets to your pattern
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var name = "@freesewing/plugin-sprinkle";
var version = "2.18.0";

var index = {
  name: name,
  version: version,
  hooks: {
    preRender: function (svg) {
      if (svg.attributes.get('freesewing:plugin-sprinkle') === false)
        svg.attributes.set('freesewing:plugin-sprinkle', version);
    },
  },
  macros: {
    sprinkle: function (so) {
      for (let pid of so.on)
        this.snippets[pid + '-' + so.snippet] = new this.Snippet(so.snippet, this.points[pid]);
    },
  },
};

export { index as default };
//# sourceMappingURL=index.mjs.map
